import { styled } from '@mui/material';
import * as React from 'react';
import CancelIcon from '@mui/icons-material/Cancel';

export const FeatureNotAvailableIcon = styled(CancelIcon)({
    color: 'lightgray',
});